"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { ARFREAKS_CATEGORIES } from "@/lib/arfreaks-categories"
import { useTranslations } from "next-intl"

interface ArfreaksFilterTabsProps {
  category: string
  onCategoryChange: (value: string) => void
}

// ARFreaks' categories (blowjob, cowgirl, handjob...), from the site's own category list; see lib/booru-sources/booru-api/arfreaks.ts.
export function ArfreaksFilterTabs({ category, onCategoryChange }: ArfreaksFilterTabsProps) {
  const t = useTranslations("arfreaksFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[{ id: "category", label: t("category"), value: category, defaultValue: "all", options: [{ value: "all", label: t("allCategories") }, ...ARFREAKS_CATEGORIES.map((c) => ({ value: c.slug, label: c.label }))] }]}
      onChange={(_, value) => onCategoryChange(value)}
    />
  )
}
